import React from 'react';

import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as _cv_70___Mz from './_cv_70___Mz';

import * as BtnCttC from './_ccmBtnCttC';

let $_70z = _cv_70___Mz.ilz_70z();

export const B = (pz: ht.btnCttCz & {
  cz: {
    grtMailsAsync: (_70z: ht.dz) => ht.ls,
  }
}) => {
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _mails = await pz.cz.grtMailsAsync($_70z);
          if (hf.f(_mails)) {
            await f.sendMailsAsync(_mails);
            // hf.l(`_cv_70___Ci 48: ${hf.s($_70z)}`);
            const _gUserz = gs.useUserz();
            hf.udtDz($_70z._70rz, {
              _70r_10r1k: _gUserz.crt._10rz._key,
              _70rd1100s: hfDTM.getNow(),
              _70rs1100i: 1, // 送信済
            });
            $_70z = await _cv_70___Mz.save_70rDzAsync({
              ... pz,
              _70z: $_70z,
            });
            return { // 送信後に一覧画面へ戻る
              steps: [0],
              _70r_fst: -1,
            };
          }
          else {
            return {
            };
          }
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz & {
  cz: {
    _70ra1100js: ht.ls
  }
}) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {

    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        _cv_70___Mz.crt_70z()
        .then((_dz: ht.dz) => {
          $_70z = _dz;
        })
      ],
      udtAsync: () => [
        _cv_70___Mz.load_70rDzAsync({
          _70r_fst: pz.sPz.crt._70r_fst,
          cdn: 'true',
        })
        .then((_dz: ht.dz) => {
          $_70z = _dz;
        })
      ],
    });

  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._70r_fst
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  //hf.l(`_cv_70___Ci 83: ${hf.s(pz.cz._70ra1100js)}`)
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dw/f dwx/80 f/n mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [            
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `宛先：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: {
                              showz: a(`bc/lt3`),
                            },
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: pz.cz._70ra1100js ?? [],
//                              ls: [],
                              vle: hf.j($_70z._70rz._70ra1100j)?.key ?? -1,
                              onChg: (_dz: ht.dz) => {
                                $_70z._70rz._70ra1100j = hf.s({
                                  key: _dz.key,
                                  pfx: _dz.pfx,
                                });
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `件名：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: {
                              showz: a(`bc/lt3`),
                            },
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_70z._70rz._pfx ?? '',
                              onChg: (_s: ht.s) => {
                                $_70z._70rz._pfx = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      boxStlz: a('fd/rss'),
                      lblCz: {
                        textz: {
                          pfx: `内容：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            boxStlz: a('dh/60 dw/f'),
                            iptStlz: {
                              showz: a(`bc/lt3 dh/f`),
                              editz: a(`dh/f`),
                            },
                            iptPtyz: a(`tm`),
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_70z._70rz._70ra2100t ?? '',
                              onChg: (_s: ht.s) => {
                                $_70z._70rz._70ra2100t = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            hf.f($_70z._70rz?._70rd1100s) ?
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `送信日時：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: hf.f($_70z._70rz?._70rd1100s) ? $_70z._70rz?._70rd1100s : 'ー',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
            hf.f($_70z._10rz?._pfx) ?
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `送信者：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: hf.f($_70z._10rz?._pfx) ? $_70z._10rz?._pfx : 'ー',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
            hf.f($_70z._70rz._icn) ?
            {
              boxStlz: a(`dw/f f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `メールID：`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: hf.f($_70z._70rz._icn) ? $_70z._70rz._icn : 'ー',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
          ]
        }),

      ]
    })
  );
};

